'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bone-break';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f5d8';
var svgPathData = 'M320 0c-4.4 0-8 3.6-8 8l0 112c0 4.4 3.6 8 8 8s8-3.6 8-8L328 8c0-4.4-3.6-8-8-8zM162.3 66.3c-3.1 3.1-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-80-80c-3.1-3.1-8.2-3.1-11.3 0zm315.3 0c-3.1-3.1-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3zM268.4 236c-1.1-4.3-5.5-6.8-9.8-5.7L167 254.9c-4.3 1.1-8.6-1.4-10.2-5.5c-14.3-38-55.5-59.7-95.5-49c-42.7 11.4-68 55.3-56.6 98c8 29.9 31.9 51.3 60.2 57.5c3.1 .7 5.7 2.9 6.5 6l.7 2.7c.8 3.1-.3 6.3-2.6 8.5c-21.4 19.5-31.4 50-23.4 79.9c11.4 42.7 55.3 68 98 56.6c40.1-10.7 64.8-50.1 58.3-90.2c-.7-4.4 1.8-8.7 6-9.9L300 384.9c4.3-1.1 6.8-5.5 5.7-9.8s-5.5-6.8-9.8-5.7L204.3 394c-13.2 3.5-19.6 16.5-17.7 27.9C191.8 454 172 485.4 140 494c-34.1 9.1-69.2-11.1-78.4-45.3c-6.4-23.9 1.6-48.3 18.7-63.9c6.3-5.8 9.8-15 7.3-24.4l-.7-2.7c-2.5-9.4-10.2-15.7-18.5-17.5c-22.7-5-41.8-22.1-48.2-46C11 260.1 31.3 225 65.4 215.8c32-8.6 65 8.7 76.4 39.1c4.1 10.9 16.1 18.9 29.3 15.4l91.6-24.6c4.3-1.1 6.8-5.5 5.7-9.8zm114.9-5.7c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8l91.6 24.6c13.1 3.5 25.2-4.5 29.3-15.4c11.5-30.4 44.4-47.7 76.4-39.1c34.1 9.1 54.4 44.2 45.3 78.4c-6.4 23.9-25.5 41-48.2 46c-8.4 1.8-16 8.1-18.5 17.5l-.7 2.7c-2.5 9.4 1 18.7 7.3 24.4c17.1 15.6 25.1 40 18.7 63.9c-9.1 34.1-44.2 54.4-78.4 45.3c-32-8.6-51.9-40.1-46.6-72.1c1.9-11.5-4.5-24.4-17.7-27.9l-91.6-24.6c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8l91.6 24.6c4.3 1.1 6.8 5.5 6 9.9c-6.6 40.1 18.2 79.4 58.3 90.2c42.7 11.4 86.5-13.9 98-56.6c8-29.9-2-60.4-23.4-79.9c-2.3-2.1-3.4-5.4-2.6-8.5l.7-2.7c.8-3.1 3.4-5.3 6.5-6c28.3-6.2 52.2-27.6 60.2-57.5c11.4-42.7-13.9-86.5-56.6-98c-40.1-10.7-81.2 10.9-95.5 49c-1.6 4.1-5.9 6.7-10.2 5.5l-91.6-24.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoneBreak = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;